<template>
  <div id="driverPort">
    <el-form
      :model="form"
      :rules="rules"
      ref="form"
      label-width="114px"
      label-position="left"
    >
      <div class="blueInfo" style="width: 744px">
        <p>
          *
          子机构获【司机端管理】权限后，可独立设置以下配置项，与主机构配置的内容互不影响
        </p>
        <p>* 如子机构未获得本权限，则以下配置项内容由主机构统一管理</p>
      </div>
      <el-form-item v-if="mixinUserInfo.platformType !== 3" label="每月结算次数" prop="settlementNum">
        <el-input
          v-model="form.settlementNum"
          maxlength="3"
          placeholder="每月能发起结算的次数"
          style="width: 205px"
        ></el-input>
        <strong
          style="
            display: inline-block;
            width: 25px;
            text-align: right;
            text-indent: 1rem;
          "
          >次
        </strong>
        <el-switch
          style="margin-left: 20px"
          v-model="form.settlementNumSwitch"
          :active-value="1"
          :inactive-value="2"
        ></el-switch>
        <p class="el-form-item-remark" style="position: relative; left: -114px">
          设置司机每月结算次数的上限，关闭后则无限制
        </p>
      </el-form-item>

      <el-form-item v-if="mixinUserInfo.platformType !== 3" label="最低结算金额" prop="settlementFee">
        <el-input
          v-model="form.settlementFee"
          maxlength="6"
          placeholder="最低申请结算的金额"
          style="width: 205px"
        ></el-input>
        <strong
          style="
            display: inline-block;
            width: 25px;
            text-align: right;
            text-indent: 1rem;
          "
        >
          元
        </strong>
        <el-switch
          style="margin-left: 20px"
          v-model="form.settlementFeeSwitch"
          :active-value="1"
          :inactive-value="2"
        ></el-switch>
        <p class="el-form-item-remark" style="position: relative; left: -114px">
          最低可结算的金额，关闭则无限制
        </p>
      </el-form-item>

<!--      <el-form-item v-if="mixinUserInfo.platformType === 3" label="收益冻结期" prop="earningsFreezeTime">-->
<!--        <el-input-->
<!--          v-model="form.earningsFreezeTime"-->
<!--          maxlength="6"-->
<!--          placeholder="最低收益冻结期"-->
<!--          style="width: 205px"-->
<!--        ></el-input>-->
<!--        <strong-->
<!--          style="-->
<!--            display: inline-block;-->
<!--            width: 25px;-->
<!--            text-align: right;-->
<!--            text-indent: 1rem;-->
<!--          "-->
<!--        >-->
<!--          天-->
<!--        </strong>-->
<!--        <el-switch-->
<!--          style="margin-left: 20px"-->
<!--          v-model="form.earningsFreeze"-->
<!--          :active-value="1"-->
<!--          :inactive-value="2"-->
<!--        ></el-switch>-->
<!--        <p class="el-form-item-remark" style="position: relative; left: -114px">-->
<!--          获得收益后先冻结，到期才可提现，次日起记为第1天，关闭则当天即可提现-->
<!--        </p>-->
<!--      </el-form-item>-->

      <el-form-item label="账号自动冻结" prop="driverFreezeTime">
        <el-input
          v-model="form.driverFreezeTime"
          maxlength="3"
          placeholder="请输入自动冻结时效"
          style="width: 205px"
        ></el-input>
        <strong
          style="
            display: inline-block;
            width: 25px;
            text-align: right;
            text-indent: 1rem;
          "
        >
          天
        </strong>
        <el-switch
          style="margin-left: 20px"
          v-model="form.driverFreeze"
          :active-value="1"
          :inactive-value="2"
        ></el-switch>
        <p class="el-form-item-remark" style="position: relative; left: -114px">
          当司机账号超过N天未登录，则会自动冻结
        </p>
      </el-form-item>

      <div class="formTitle">权限管理</div>

      <el-form-item v-if="mixinUserInfo.platformType !== 3" label="创建班次" prop="driverScheduling">
        <span
          class="el-form-item-remark"
          style="display: inline-block; width: 250px"
          >司机可主动绑定线路/班次
        </span>
        <el-switch
          v-model="form.driverScheduling"
          :active-value="1"
          :inactive-value="2"
        ></el-switch>
      </el-form-item>
      <el-form-item v-if="mixinUserInfo.platformType !== 3" label="司机代下单" prop="driverExchangeOrder">
        <span
          class="el-form-item-remark"
          style="display: inline-block; width: 250px"
          >司机可以帮助乘客进行代下单
        </span>
        <el-switch
          v-model="form.driverExchangeOrder"
          :active-value="1"
          :inactive-value="2"
        ></el-switch>
      </el-form-item>
      <!-- <el-form-item label="司机刷脸上线" prop="driverFaceRecognition">
        <div style="display: flex; align-items: center">
          <span
            class="el-form-item-remark"
            style="display: inline-block; width: 250px"
            >司机每次上线APP会进行人脸识别
          </span>
          <el-switch
            v-model="form.driverFaceRecognition"
            :active-value="1"
            :inactive-value="2"
          ></el-switch>
        </div>
      </el-form-item> -->
      <el-form-item label="司机刷脸认证" prop="driverFaceAuthentication">
        <div style="display: flex; align-items: center">
          <span
            class="el-form-item-remark"
            style="display: inline-block; width: 250px"
            >注册提交认证资料时会进行人脸识别
          </span>
          <el-switch
            v-model="form.driverFaceAuthentication"
            :active-value="1"
            :inactive-value="2"
          ></el-switch>
        </div>
      </el-form-item>
      <el-form-item label="司机行程录音权限" prop="driverFaceAuthentication">
        <div style="display: flex; align-items: center">
          <span
              class="el-form-item-remark"
              style="display: inline-block; width: 250px"
          >司机在点击开始行程时进行录音权限配置
          </span>
          <el-switch
              v-model="form.driverRecording"
              :active-value="1"
              :inactive-value="2"
          ></el-switch>
        </div>
      </el-form-item>

      <el-form-item  v-if="mixinUserInfo.platformType == 2" label="司机报班" prop="driverFaceAuthentication">
        <div style="display: flex; align-items: center">
          <span
              class="el-form-item-remark"
              style="display: inline-block; width: 250px"
          >司机可以报安检有效期内的班次
          </span>
          <el-switch
              v-model="form.driverRegister"
              :active-value="1"
              :inactive-value="2"
          ></el-switch>
        </div>
      </el-form-item>

      <div class="formTitle">支付管理</div>

      <el-form-item label="钱包充值" prop="driverRecharge">
        <span
          class="el-form-item-remark"
          style="display: inline-block; width: 250px"
          >司机钱包充值</span
        >
        <el-switch
          v-model="form.driverRecharge"
          :active-value="1"
          :inactive-value="2"
        ></el-switch>
      </el-form-item>
      <el-form-item label="微信支付充值" prop="driverRechargeWechat">
        <span
          class="el-form-item-remark"
          style="display: inline-block; width: 250px"
          >可用微信进行钱包充值
        </span>
        <el-switch
          v-model="form.driverRechargeWechat"
          :active-value="1"
          :inactive-value="2"
        ></el-switch>
      </el-form-item>

      <el-form-item v-if="mixinUserInfo.platformType !== 3" label="微信支付下单" prop="driverOrderWechat">
        <span
          class="el-form-item-remark"
          style="display: inline-block; width: 250px"
          >司机可用微信进行代下单
        </span>
        <el-switch
          v-model="form.driverOrderWechat"
          :active-value="1"
          :inactive-value="2"
        ></el-switch>
      </el-form-item>
      <el-form-item v-if="mixinUserInfo.platformType !== 3" label="支付宝支付下单" prop="driverOrderAli">
        <span
          class="el-form-item-remark"
          style="display: inline-block; width: 250px"
          >司机可用支付宝进行代下单
        </span>
        <el-switch
          v-model="form.driverOrderAli"
          :active-value="1"
          :inactive-value="2"
        ></el-switch>
      </el-form-item>

      <el-form-item style="padding: 10px 0 50px 0">
        <el-button type="primary" @click="saveClick" :loading="loading"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "driverPort",
  data() {
    return {
      // 表单
      form: {
        settlementNum:'',
        settlementFee:'',
        earningsFreezeTime:'',
        driverFreezeTime:""
      },
      // 校验规则
      rules: {
        settlementNum: [
          { required: false, message: "每月结算次数" },
          {
            pattern: /^\d{1,3}$/,
            message: "该输入框只允许输入0和1-3位的整数，不允许输入小数",
          },
        ],

        settlementFee: [
          { required: false, message: "最低结算金额" },
          {
            pattern: /^\d{1,6}$/,
            message: "该输入框只允许输入0和1-6位的整数，不允许输入小数",
          },
        ],
        earningsFreezeTime: [
          { required: false, message: "收益冻结期" },
          {
            pattern: /^\d{1,6}$/,
            message: "该输入框只允许输入0和1-6位的整数，不允许输入小数",
          },
        ],
        driverFreezeTime: [
          { required: false, message: "最低结算金额" },
          {
            pattern: /^(?:(?!0$))\d{1,3}$/,
            message: "该输入框只允许输入1-3位的正整数，不允许输入小数",
          },
        ],
      },
      // 保存按钮loading
      loading: false,
    };
  },
  methods: {
    /**
     * 点击保存
     */
    async saveClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.postFn();
        } else {
          this.$message.warning("请检查表单数据是否输入正确！");
          return false;
        }
      });
    },
    /**
     * 接口请求-提交配置
     */
    async postFn() {
      this.loading = true;
      let url =
        this.mixinUserInfo.organizationType === 1
          ? "/api/v1/manage/systems"
          : "/api/v1/manage/systems/driver";
      let params = this.$utils.deepCopyFn(this.form);
      let data = await this.$axios.put(url, Object.assign(params, { systemFlag: 2 }));
      if (data && data.code === 1) {
        this.$message.closeAll();
        this.$message.success("保存成功！");
        this.driverInfo();
      }
      this.loading = false;
    },
    /**
     * 获取配置详情
     */
    async driverInfo() {
      let url =
        this.mixinUserInfo.organizationType === 1
          ? "/api/v1/manage/systems"
          : "/api/v1/manage/systems/driver/" +
            this.mixinUserInfo.organizationId;
      let data = await this.$axios.get(url);
      if (data && data.code === 1) {
        this.form = data.data || {};
      }
    },
  },
  created() {
    this.driverInfo();
  },
};
</script>

<style lang="less">
#driverPort {
  .el-radio-item .el-radio__label {
    font-weight: 600;
    color: #222222;
  }

  .el-radio-item + .el-radio-item {
    padding-top: 8px;
  }

  .el-radio-item .el-form-item-remark {
    padding-top: 8px;
  }
}
</style>
